import { AirlineLiteModel } from 'api-hooks/airline';
import { CustomerLiteModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestVisaDocumentModel } from 'api-hooks/guest';
import { HotelLiteModel } from 'api-hooks/hotel';
import { Expose, Type } from 'class-transformer';
import {
  CategoryTypeEnum,
  HotelCheckInStatusEnum,
  DocumentTypeEnum,
  FlightCheckInStatusEnum,
  InsuranceTypeEnum,
} from 'common/constants/enum';
import {
  CommonParamInput,
  MinimalCommonModel,
} from 'common/repositories/common.model';

export class GuestBirthdayLiteModel {
  id: string;
  name: string;

  @Expose({ name: 'birth_date' })
  @Type(() => Date)
  birthDate: Date;

  category: CategoryTypeEnum;
}

export class GuestDocumentLiteModel {
  id: string;

  @Type(() => MinimalCommonModel)
  guest: MinimalCommonModel;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  //visa
  @Expose({ name: 'visa_document' })
  @Type(() => GuestVisaDocumentModel)
  visaDocument?: GuestVisaDocumentModel;

  //insurance
  type?: InsuranceTypeEnum;

  // visa - insurance
  number?: string;
}

export class GuestFlightScheduleLiteModel {
  id: string;

  @Expose({ name: 'check_in_status' })
  checkInStatus: FlightCheckInStatusEnum | null;

  customer: MinimalCommonModel;

  @Type(() => Date)
  date: Date;

  guests: MinimalCommonModel[];

  @Type(() => AirlineLiteModel)
  airline: AirlineLiteModel;

  route: string;
  time: string;

  @Expose({ name: 'booking_code' })
  bookingCode: string | null;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'sale_id' })
  saleId: string;

  @Type(() => EmployeeLiteModel)
  lead: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  sales: EmployeeLiteModel;
}

export class GuestHotelScheduleLiteModel {
  id: string;

  @Expose({ name: 'check_in_status' })
  checkInStatus: HotelCheckInStatusEnum | null;

  @Expose({ name: 'hotel_confirmation_code' })
  hotelConfirmationCode: string | null;

  @Expose({ name: 'check_in' })
  @Type(() => Date)
  checkIn: Date | null;

  @Expose({ name: 'check_out' })
  @Type(() => Date)
  checkOut: Date | null;

  @Type(() => HotelLiteModel)
  hotel: HotelLiteModel;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  guests: MinimalCommonModel[];

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'sale_id' })
  saleId: string;

  @Type(() => EmployeeLiteModel)
  lead: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  sales: EmployeeLiteModel;
}

export type getGuestBirthdayFilterType = {
  name?: string | null;
  category?: string | null;
  birthday_at_after?: string | null;
  birthday_at_before?: string | null;
};

export type getGuestBirthdaySortType =
  | 'name'
  | '-name'
  | 'birth_date'
  | '-birth_date'
  | 'category'
  | '-category';

export type getGuestBirthdayInput = CommonParamInput<
  {
    n?: number;
    params?: any;
  },
  getGuestBirthdayFilterType
>;

export type getGuestDocumentSortType =
  | 'guest_name'
  | '-guest_name'
  | 'expired_at'
  | '-expired_at';

export type getGuestDocumentFilterType = {
  guest_name?: string;
};

export type getGuestDocumentInput = CommonParamInput<
  {
    document_type: DocumentTypeEnum;
    month?: number;
    params?: any;
  },
  getGuestDocumentFilterType
>;

export type getGuestFlightScheduleType =
  | 'ticket'
  | '-ticket'
  | 'date'
  | '-date';

export type getGuestFlightScheduleFilter = {
  ticket?: string | null;
  date_after?: string | null;
  date_before?: string | null;
};

export type getGuestFlightScheduleInput = CommonParamInput<
  { n?: number; params?: any },
  getGuestFlightScheduleFilter
>;

export type getGuestHotelScheduleFilterType = {
  check_in_status?: string | null;
  hotel_name?: string | null;
  customer_name?: string | null;
  sale_number?: string | null;
  check_in_after?: string | null;
  check_in_before?: string | null;
};

export type getGuestHotelScheduleSortType =
  | 'status'
  | '-status'
  | 'check_in'
  | '-check_in'
  | 'check_out'
  | '-check_out'
  | 'hotel_name'
  | '-hotel_name'
  | 'customer_name'
  | '-customer_name';

export type getGuestHotelScheduleInput = CommonParamInput<
  {
    n?: number;
    params?: any;
  },
  getGuestHotelScheduleFilterType
>;

export type MassUpdateFlightScheduleMutationInput = {
  flightSchedules: {
    id: string;
    checkInStatus: FlightCheckInStatusEnum | null;
  }[];
};

export type MassUpdateHotelScheduleMutationInput = {
  hotelSchedules: {
    id: string;
    checkInStatus: HotelCheckInStatusEnum | null;
    hotelConfirmationCode: string;
  }[];
};
